class KawaiiwaruMobileShopBar extends HTMLElement {
  connectedCallback() {
    this.addButton = this.querySelector('[data-kw-mobile-add]');
    if (!this.addButton) return;

    this.productSubmit = document.querySelector('.product-form__submit');
    this.productForm = this.productSubmit?.closest('form') || document.querySelector('product-form form');
    this.handleAdd = this.handleAdd.bind(this);
    this.syncState = this.syncState.bind(this);

    this.addButton.addEventListener('click', this.handleAdd);
    this.syncState();

    if (this.productSubmit) {
      this.observer = new MutationObserver(this.syncState);
      this.observer.observe(this.productSubmit, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
      });
    }
  }

  disconnectedCallback() {
    this.addButton?.removeEventListener('click', this.handleAdd);
    this.observer?.disconnect();
  }

  handleAdd() {
    if (!this.productForm || this.addButton.disabled) {
      document.querySelector('.product__info-container')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    this.productForm.requestSubmit();
  }

  syncState() {
    if (!this.productSubmit || !this.addButton) return;

    this.addButton.disabled = this.productSubmit.disabled;
    const label = this.productSubmit.querySelector('span')?.textContent?.trim();
    if (label) this.addButton.querySelector('[data-kw-mobile-add-label]').textContent = label;
  }
}

if (!customElements.get('kawaiiwaru-mobile-shop-bar')) {
  customElements.define('kawaiiwaru-mobile-shop-bar', KawaiiwaruMobileShopBar);
}
